export default {"src":"/_next/static/media/triangle-left.7ac56e31.svg","height":10,"width":5,"blurWidth":0,"blurHeight":0};